// --- Shared cross-subdomain cookie helpers (domain=.lookoptic.com) ---
// Defined once and shared across the LOOK OPTIC theme scripts so state written
// on www.lookoptic.com is visible on try.lookoptic.com and vice-versa.
(function () {
  if (window.__sharedCookieHelpersInstalled) return;
  window.__sharedCookieHelpersInstalled = true;

  window.setSharedCookie = function (name, value, days) {
    document.cookie =
      name + "=" + encodeURIComponent(value) +
      "; domain=.lookoptic.com; path=/; SameSite=Lax; Secure" +
      "; max-age=" + (days * 86400);
  };

  window.getSharedCookie = function (name) {
    var cookies = document.cookie ? document.cookie.split("; ") : [];
    for (var i = 0; i < cookies.length; i++) {
      var idx = cookies[i].indexOf("=");
      var key = idx > -1 ? cookies[i].slice(0, idx) : cookies[i];
      if (key === name) {
        return decodeURIComponent(idx > -1 ? cookies[i].slice(idx + 1) : "");
      }
    }
    return null;
  };

  window.removeSharedCookie = function (name) {
    document.cookie = name + "=; domain=.lookoptic.com; path=/; max-age=0";
  };
})();

window.utilShippingThreshold = function(thresholdAmount, override = false) {
  // remember threshold
  // Prefer the shared cookie, fall back to localStorage during rollout.
  var existingThreshold =
    getSharedCookie('shipping_threshold_amount') || window.localStorage.getItem('shipping_threshold_amount');
  if (!existingThreshold || override) {
    // Dual-write: shared cookie (cross-subdomain) + localStorage (legacy readers).
    setSharedCookie('shipping_threshold_amount', thresholdAmount, 30);
    window.localStorage.setItem('shipping_threshold_amount', thresholdAmount);
  }
  
  // Disconnect existing observer if it exists
  if (window._shippingThresholdObserver) {
    window._shippingThresholdObserver.disconnect();
    window._shippingThresholdObserver = null;
  }
  // Clear existing debounce timer if it exists
  if (window._shippingThresholdDebounceTimer) {
    clearTimeout(window._shippingThresholdDebounceTimer);
    window._shippingThresholdDebounceTimer = null;
  }
  
  const SELECTOR = 'span[data-shipping-threshold]';
  const threshold = `$${thresholdAmount}`;
  
  function replaceShippingThreshold(el) {
    if (el.dataset.thresholdReplaced && !override) return;
    el.innerHTML = threshold;
    el.dataset.thresholdReplaced = 'true';
  }
  
  function handleInitialElements() {
    document.querySelectorAll(SELECTOR).forEach(el => replaceShippingThreshold(el));
  }
  
  // Debounced processing function
  function processQueuedNodes() {
    if (window._shippingThresholdNodeQueue && window._shippingThresholdNodeQueue.length > 0) {
      const nodes = [...window._shippingThresholdNodeQueue];
      window._shippingThresholdNodeQueue = [];
      
      nodes.forEach((node) => {
        try {
          if (node.nodeType !== 1) return;
          if (node.matches?.(SELECTOR)) {
            replaceShippingThreshold(node);
          }
          node.querySelectorAll?.(SELECTOR).forEach(child => replaceShippingThreshold(child));
        } catch (e) {
          console.warn('Threshold replacement error:', e);
        }
      });
    }
  }
  
  function observeNewElements() {
    // Initialize node queue
    window._shippingThresholdNodeQueue = [];
    
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          // Add nodes to queue instead of processing immediately
          window._shippingThresholdNodeQueue.push(node);
        });
      });
      
      // Clear existing timer and set new one
      if (window._shippingThresholdDebounceTimer) {
        clearTimeout(window._shippingThresholdDebounceTimer);
      }
      
      // Process queued nodes after 50ms of inactivity
      window._shippingThresholdDebounceTimer = setTimeout(() => {
        processQueuedNodes();
        window._shippingThresholdDebounceTimer = null;
      }, 50);
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    
    // Store reference to the observer globally so we can clean it up later
    window._shippingThresholdObserver = observer;
  }
  
  function waitForElementToDisplay(selector, callback, interval = 100, timeout = 10000) {
    const start = Date.now();
    const timer = setInterval(() => {
      if (document.querySelector(selector)) {
        clearInterval(timer);
        callback();
      } else if (Date.now() - start > timeout) {
        clearInterval(timer);
        console.warn(`waitForElementToDisplay: Timed out waiting for ${selector}`);
      }
    }, interval);
  }
  
  waitForElementToDisplay(
    SELECTOR,
    () => {
      handleInitialElements();
      observeNewElements();
    },
    100,
    10000
  );
}

// if (window.localStorage.getItem('shipping_threshold_amount')) {
//   window.utilShippingThreshold(window.localStorage.getItem('shipping_threshold_amount'));
// }

window.utilShippingThreshold(130, false);